require("bootstrap-daterangepicker/daterangepicker.css");

import 'bootstrap-daterangepicker';
import moment from 'moment';

function enableDateFields($scope) {
  const submitDateFormat = 'DD/MM/YYYY';

  function clearDate(event) {

    // don't submit the form.
    event.preventDefault();

    // find a bunch of relevant elements.
    var $dateField = $(event.target).closest('.date-input').find('input');

    // clear the cloudinary id.
    $dateField.val(null);

  }

  $scope.find('input.single-daterange:not(.single-daterange-with-time)').each(function () {
    const $input = $(this);
    const dateFormat = $input.attr('date_format') || submitDateFormat;

    if ($input.data('daterangepicker')) {
      $input.data('daterangepicker').remove();
    }

    const isFutureOnly = $input.hasClass('future-only');

    $input.daterangepicker({
      showDropdowns: true,
      minYear: new Date().getFullYear() - 100,
      maxYear: new Date().getFullYear() + 5,
      singleDatePicker: true,
      autoUpdateInput: false,
      parentEl: $input.closest('.date-input')[0],
      locale: {
        cancelLabel: 'Clear',
        format: dateFormat,
      },
      ...(isFutureOnly ? { minDate: new Date(), minYear: new Date().getFullYear() } : {})
    });

    $input.off('apply.daterangepicker cancel.daterangepicker');

    $input.on('apply.daterangepicker', function (ev, picker) {
      $(this).val(picker.startDate.format(dateFormat));
    });

    $input.on('cancel.daterangepicker', function () {
      $(this).val('');
    });
  });

  $scope.find(".date-input button.clear").off('click').on('click', clearDate);
}

$(document).on('turbolinks:load', function () {
  enableDateFields($('body'));
});

$(document).on('sprinkles:update', function (event) {
  enableDateFields($(event.target));
});
